import { TASK_SERVICE } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_LABEL_CONFIG = `${TASK_SERVICE}/label-config`;

export const labelConfig = {
  get: async ({ dependentType, area, isActive } = {}) => {
    const options = await apiOptions({
      url: `${API_LABEL_CONFIG}/${dependentType}/${area}${
        isActive ? "/active" : ""
      }`,
      method: "get",
    });
    return apiRequest(options);
  },
  update: async ({ dependentType, area, data, toastMessageConfig = {} }) => {
    const options = await apiOptions({
      url: `${API_LABEL_CONFIG}/${dependentType}/${area}`,
      method: "put",
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
};
